<template>
<div class="userpage">
    <div v-if="!jtoken" id="login">
      <p style="display:inlinefont-size:1emcolor:whitemargin-right:5px">If you are already registered log in:</p>
      <v-btn style="display:inlinemax-height:12pxfont-size:0.7empadding:0px 5px 0px 5pxmargin:0pxmin-width:50pxwidth:auto" color="primary" @click="gotologin()"> LOGIN </v-btn>
    </div>
    <div v-if="jtoken" id="login">
      <p style="display:inlinefont-size:1emcolor:whitemargin-right:5px">If you want to log out </p>
      <v-btn style="display:inlinemax-height:12pxfont-size:0.7empadding:0px 5px 0px 5pxmargin:0pxmin-width:50pxwidth:auto" color="primary" @click="logout()"> Logout </v-btn>
      <p style="display:inlinefont-size:1emcolor:whitemargin-right:5px"> or</p>
      <v-btn style="display:inlinemax-height:12pxfont-size:0.7empadding:0px 5px 0px 5pxmargin:0pxmin-width:50pxwidth:auto" color="primary" @click="gotobooking()"> MAKE A ORDER </v-btn>
    </div>
    <div id="container">
      <div id="info">
        <div id="features" class="section">
          <div class="subsection">
            <h4 id="name">Name and last name</h4>
            {{registration.name}} {{registration.lastname}}
          </div>
          <div class="subsection">
            <h4 id="nationality">Nationality</h4>
            {{registration.nationality}}
          </div>
          <div class="subsection">
            <h4 id="phone">Phone</h4>
            {{registration.number}}
          </div>
          <div class="subsection">
            <h4 id="email">Contact email</h4>
            {{registration.contact_email}}
          </div>
          <div class="subsection">
            <h4 v-if="registration.birthday" id="birthday">Birthday</h4>
            {{registration.birthday}}
          </div>
        </div>
        <br><br>

        <v-label>Select the order you want to review</v-label><br>
        <select id="order" v-model="chosen_order">
          <option value="" v-if="chosen_order===''">Select the order</option>
          <option :value="item.order_id" v-for="item in order_list" :key="item.order_id">Item n° {{item.order_id}} </option>
        </select><br>

        <br><br>
        <div v-if="order_id" id="details" class="section">
          <h3>Order details</h3>
          <div class="subsection">
            <h4 id="routers_quantity">Routers booked</h4>
            {{quot_order.routers_quantity}}
          </div>
          <div class="subsection">
            <h4 id="startdate">Booking starting from</h4>
            {{quot_order.startdate}}
          </div>
          <div class="subsection">
            <h4 id="enddate">Booking ending on</h4>
            {{quot_order.enddate}}
          </div>
          <div v-if="quot_order.insurance" class="subsection">
            <h4 id="insurance">Insurance</h4>
            {{quot_order.insurance}}
          </div>
          <div class="subsection">
            <h4 id="shipping">Pick-up location</h4>
            {{quot_order.shipping.city}}, at {{quot_order.shipping.loc}}
            <div v-if="quot_order.shipping.info">{{quot_order.shipping.info}}</div>
          </div>
          <div class="subsection">
            <h4 id="rshipping">Return location</h4>
            {{quot_order.rshipping.city}}, at {{quot_order.rshipping.loc}}
            <div v-if="quot_order.rshipping.info">{{quot_order.rshipping.info}}</div>
          </div>
          <div class="subsection">
            <h4 id="shiptotal">Shipping cost</h4>
            {{quot_order.shiptotal}}
          </div>
          <div v-if="quot_order.sim" class="subsection">
            <h4 id="sim">BNE sim</h4>
            {{quot_order.sim}}
          </div>
        </div>

      </div>
    </div>
</div>
</template>

<script>
import apiService from '@/services'
// const loginService = new ApiService()

export default {
  name: 'userpage',
  data: () => ({
    loggedin: localStorage.loggedin,
    order_list: (localStorage.order_list) ? JSON.parse(localStorage.order_list) : [],
    chosen_order: (localStorage.chosen_order) ? localStorage.chosen_order : '',
    jtoken: (localStorage['x-token']) ? localStorage['x-token'] : null,
    orders: null,
    order_id: (localStorage.order_id) ? localStorage.order_id : null,
    registration: {
      name: null,
      lastname: null,
      nationality: null,
      contact_email: null,
      birthday: null,
      number: null
    },
    quot_order: {
      orderdays: null,
      routers_quantity: null,
      startdate: null,
      enddate: null,
      insurance: null,
      shipping: null,
      rshipping: null,
      shiptotal: null,
      total: null,
      sim: null
    }
  }),
  methods: {
    logout () {
      localStorage['x-token'] = null
      localStorage.loggedin = false
      this.$router.push({
        name: 'login'
      })
    },
    gotologin () {
      this.$router.push({
        name: 'login'
      })
    },
    gotobooking () {
      this.$router.push({
        name: 'booking'
      })
    }
  }
}
</script>

<style scoped>
#order {
  margin-bottom: 10px;
  margin-top: 5px;
  border-style: solid;
  border-width: 0px 0px 1px 0px;
  border-color: rgba(0, 0, 0, 0.4);
  border-radius: 0px;
}

#login {
  position: relative;
  padding-left: 35px;
  background-color: black;
  width: 100%;
  min-height: 20px;
  max-height: 100px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  display: block;
  align-items: right;
  text-align: right;
  color: white;
}

#title {
  position: relative;
  padding: 1vmax;
  height: 5vmax;
  width: 100%;
  display: block;
  text-align: center;
  color: white;
  font-size: 1.5rem;
  background-color: rgba(99, 143, 255, 1);
}

#normhr {
  padding: 1px;
  margin: 0px;
  border-style: hidden;
  display: block;
  overflow: hidden;
  background-color: white;
}

.subsection {
  color: black;
  padding: 5px;
  text-align: left;
  background-color: white;
}

.section {
  text-align: center;
  padding-bottom: 20px;
  background-color: white;
}

#info {

  height: auto;
  padding-left: 30vmax;
  padding-right: 30vmax;
  padding-left: 15vmin;
  padding-right: 15vmin;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: white;
  font-size: 15px;
}

h4 {
  color: grey;
  font-weight: normal;
  width: 200px;
  font-size: 18px;
  margin: 1vh 2px 1vh 2px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgba(0, 0, 0, 0.5);
}

h3 {
  color: rgba(99, 143, 255, 1);
  margin: 0px;
  font-weight: bold;
  font-size: 18px;
  padding: 1vh 2px 1vh 2px;
}

.label {
  color: grey;
  border-bottom: solid 1px grey;

}

#container {
  height: auto;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}

#card {
  margin: 20px;
  size: 50vmax;
  max-height: auto;
  background-color: white;
}
</style>
